import didilogo from '../assets/images/didiLogo.png';
import didilogo_line from '../assets/images/didiLogo_line.png';

export const DIDI_LOGO = didilogo;
export const DIDI_LOGO_LINE = didilogo_line;
